import { translate } from '../../../i18n';
import { WILDCARD_CAPACITY } from '../../../utils/sport-capacity';

/**
 * Labels the price point a recommendation belongs to.
 *
 * A recommendation is one (court, sport, window, **duration**, **capacity**)
 * price point. Before capacity and duration were part of the grouping key, two
 * price points for the same court/sport/window were merged into one row and
 * applying it wrote a single price over both — a Padel-4 price silently
 * collapsing onto the Padel-2 recommendation. They are separate rows now, so
 * the table has to say which is which or they read as duplicates.
 */
export function formatPricePoint(
    capacity: number,
    slotDurationInMs: number,
): string {
    const capacityLabel =
        capacity === WILDCARD_CAPACITY
            ? translate('courts.all_capacities')
            : `${capacity} ${translate('game_capacity_options.players')}`;

    // Guard the duration: a malformed row should degrade to the capacity label
    // rather than render "NaN min" next to a price the operator is about to
    // change.
    if (!Number.isFinite(slotDurationInMs) || slotDurationInMs <= 0) {
        return capacityLabel;
    }

    const minutes = Math.round(slotDurationInMs / 60000);
    return `${capacityLabel} · ${minutes} ${translate(
        'pricing_insights.min_short',
    )}`;
}
